import { render, staticRenderFns } from "./ModalTirilla.vue?vue&type=template&id=7458e535"
import script from "./ModalTirilla.vue?vue&type=script&lang=js"
export * from "./ModalTirilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports